import React from "react";
import Header from "./Header";

const Layout = ({ children }) => {
  return (
    <div className="app-shell">
      <Header />
      <main className="app-shell__content">
        {children}
      </main>
    </div>
  );
};

export default Layout;
